import { Typography } from '@mui/material';
import ContainerBox from 'components/ContainerBox';
import React from 'react';
import * as ActiveProductSelectors from 'selectors/ActiveProductSelectors';
import * as ActiveProductActions from 'actions/ActiveProductActions';
import { useSelector, useDispatch } from 'react-redux';
import SegmentVisibilitySettings from 'components/SegmentVisibilitySettings';
import { useTranslation } from 'services/localization';

const Segments = () => {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const product = useSelector(ActiveProductSelectors.productDataWithChanges);
	const isEditingDisabled = useSelector(ActiveProductSelectors.isEditingDisabled);

	return (
		<ContainerBox>
			<Typography variant="h6">
				{t('common:customerSegment.plural', 'Customer segments')}
			</Typography>
			<Typography variant="body2" color="secondary" sx={{ mb: 4 }}>
				{t('Segments.subheader', 'Select the customer segments to use with this product')}
			</Typography>
			<SegmentVisibilitySettings
				sx={{ mt: 4 }}
				value={product.segmentFilters ?? []}
				onChange={(value) =>
					dispatch(ActiveProductActions.editLocalProduct({ segmentFilters: value }))
				}
				disabled={isEditingDisabled}
			/>
		</ContainerBox>
	);
};

export default Segments;
